application.register("comp_visual", class extends Stimulus.Controller {
    scrollToNext() {
        LibAnchor.animation(this.element.nextElementSibling);
    }
});